import { Link } from "react-router-dom";
import { Star, ShieldCheck, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`}
      className="group bg-white rounded-3xl border border-gray-100 overflow-hidden hover:border-[#FF5C28] hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-all duration-300 flex flex-col">
      <div className="relative aspect-square bg-[#F8F9FA] overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-[#FF5C28] text-white text-xs font-bold px-3 py-1 rounded-full">{product.badge}</span>
        )}
        <button onClick={handleAdd} data-testid={`quick-add-${product.slug}`}
          className="absolute bottom-3 right-3 w-10 h-10 rounded-full bg-[#0F0F0F] text-white flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all hover:bg-[#FF5C28]">
          <Plus className="w-5 h-5" strokeWidth={2.5} />
        </button>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-1 mb-2">
          <Star className="w-3.5 h-3.5 fill-[#FF5C28] text-[#FF5C28]" />
          <span className="text-xs font-bold">{product.rating}</span>
          <span className="text-xs text-gray-400">({product.reviews_count})</span>
          {product.vet_reviewed && (
            <span className="ml-auto inline-flex items-center gap-1 text-[10px] font-bold text-emerald-600">
              <ShieldCheck className="w-3.5 h-3.5" /> Vet Reviewed
            </span>
          )}
        </div>
        <h3 className="font-display font-bold text-base leading-tight mb-1 group-hover:text-[#FF5C28] transition-colors">{product.name}</h3>
        <p className="text-sm text-gray-500 line-clamp-2 flex-1">{product.short_description}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-display font-extrabold text-lg">{product.price === 0 ? "Free" : `$${product.price.toFixed(2)}`}</span>
          <span className="text-xs font-bold text-[#FF5C28] group-hover:underline">View →</span>
        </div>
      </div>
    </Link>
  );
};
